
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/footerPage/FooterPage",
      function () {
        return require("private-next-pages/footerPage/FooterPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/footerPage/FooterPage"])
      });
    }
  